<template>
    <div>
    <app-toolbarcustom app_title="SOP" app_menu="bot"></app-toolbarcustom>
    <v-card flat>
        <v-list two-line>
            <v-subheader></v-subheader>
            <template v-for="(item, index) in filteredposts">
                <v-list-item
                  :key="item.text"
                  @click="GoTo(item.url, item.description)"
                >
                  <v-list-item-avatar>
                    <v-icon>folder</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                v-if="index + 1 < filteredposts.length"
                :key="index"
              ></v-divider>
           </template>
        </v-list>
    </v-card>
    </div>
</template>
<script>
    export default {
        data: () => ({
            loading: false,
            posts: [
                {icon: 'folder', text: 'Audit dan Kepatuhan', description: 'Audit dan Kepatuhan', url:'audit',company: 'OPI'},
                {icon: 'folder', text: 'Bisnis dan Operasional', description: 'Bisnis dan Operasional', url:'bisnis',company: 'OPI'},
                {icon: 'folder', text: 'Keuangan dan Manajemen Risiko', description: 'Keuangan dan Manajemen Risiko', url:'keuangan',company: 'OPI'},
                {icon: 'folder', text: 'SDM dan Umum', description: 'SDM dan Umum', url:'sdmumum',company: 'OPI'},
                {icon: 'folder', text: 'IT', description: 'IT', url:'it',company: 'OPI'},
            ]
        }),
        computed: {
            filteredposts() {
                return this.posts.filter(post => {
                    if (this.$functions.UsersCompany() !== '') {
                        return post.company === 'ALL' || post.company === this.$functions.UsersCompany()
                    } else {
                        return post
                    }
                }
                )
            },
        },
        methods: {
            GoTo (url, desc) {
                if (url === 'notavailable') {
                    alert('Coming Soon')
                } else {
                    this.$router.push({name: 'soplist',params:{id:this.$functions.EncodeUrl(url+"&"+desc)}})
                }
            }
        }
    }
</script>